module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_vaina.8425cf4a.png";